export default __webpack_public_path__ + "717ffb22abd3aad59a495e2531562fb6.svg";